export const CHECK_FILTER = "CHECK_FILTER";

export const FILTER_GET_NEXT_STEP = "FILTER_GET_NEXT_STEP";

export const FILTER_GET_NEXT_STEP_VACXIN = "FILTER_GET_NEXT_STEP_VACXIN";
export const SET_GUARANTEE_COMPANY = "SET_GUARANTEE_COMPANY";
export const FILTER_SAVE_GUARANTEE_COMPANY = "FILTER_SAVE_GUARANTEE_COMPANY";
export const GET_FILTER_BY_STEP = "GET_FILTER_BY_STEP";
export const RESET_FILTER_BY_STEP = "RESET_FILTER_BY_STEP";
export const SET_FILTER_BY_STEP = "SET_FILTER_BY_STEP";
